import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import AppLayoutWorkbench from '@/components/AppLayoutWorkbench'
import AppLayoutYourSite from '@/components/AppLayoutYourSite'
import AppLayoutSetting from '@/components/AppLayoutSetting'
import Login from '@/views/Login'
import ForgotPassword from '@/views/ForgotPassword'
import LoginNext from '@/views/LoginNext'
import Home from '@/views/Home'
import Traffic from '@/views/Traffic'
import Keyword from '@/views/Keyword'
import Article from '@/views/Article'
import ArticleInfo from '@/views/ArticleInfo'
import ArticleEdit from '@/views/ArticleEdit'
import ArticleList from '@/views/ArticleList'
import ArticleListPublish from '@/views/ArticleListPublish'
import ArticleListPendingAudit from '@/views/ArticleListPendingAudit'
import ArticleListAuditReject from '@/views/ArticleListAuditReject'
import ArticleListDraft from '@/views/ArticleListDraft'
import Product from '@/views/Product'
import ProductList from '@/views/ProductList'
import ProductEdit from '@/views/ProductEdit'
import Case from '@/views/Case'
import CaseList from '@/views/CaseList'
import CaseEdit from '@/views/CaseEdit'
import SettingPersonal from '@/views/SettingPersonal'
import SettingPersonalInfo from '@/views/SettingPersonalInfo'
import SettingPersonalBind from '@/views/SettingPersonalBind'
import SettingPersonalPassword from '@/views/SettingPersonalPassword'
// import SettingCompany from '@/views/SettingCompany'
// import SettingCompanyInfo from '@/views/SettingCompanyInfo'
import SitePages from '@/views/SitePages'
import SiteEditor from '@/views/SiteEditor'
import NotFound from '@/views/NotFound'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: { name: 'Login' }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { title: '登录', icon: '' }
    },
    {
      path: '/login/forgot',
      name: 'ForgotPassword',
      component: ForgotPassword,
      meta: { title: '忘记密码', icon: '' }
    },
    {
      path: '/login/next',
      name: 'LoginNext',
      component: LoginNext,
      meta: { title: '关键词配置', icon: '' },
      beforeEnter: (to, from, next) => {
        store.dispatch('getGlobalConfig', {
          params: { userId: store.state.account.user.id }
        }).then(response => {
          next()
        }).catch(error => {
          console.log('[DEBUG] get global config error:', error)
          next()
        })
      }
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      props: {
        needFooter: true
      },
      meta: { title: '推广首页', icon: '' }
    },
    {
      path: '/workbench',
      name: 'Workbench',
      redirect: { name: 'Keyword' },
      component: AppLayoutWorkbench,
      meta: { title: '智能搜索', icon: '' },
      children: [
        {
          path: 'keyword',
          name: 'Keyword',
          component: Keyword,
          meta: { title: '关键词', icon: 'keyword' }
        },
        {
          path: 'traffic',
          name: 'Traffic',
          component: Traffic,
          meta: { title: '流量', icon: 'traffic' }
        },
        {
          path: 'article',
          name: 'Article',
          component: Article,
          redirect: { name: 'ArticleInfo' },
          meta: { title: '文章发布', icon: 'topic' },
          children: [
            {
              path: 'info',
              name: 'ArticleInfo',
              component: ArticleInfo,
              meta: { title: '概况', icon: '' }
            },
            {
              path: 'edit',
              name: 'ArticleEdit',
              component: ArticleEdit,
              meta: { title: '发布文章', icon: '' }
            },
            {
              path: 'list',
              name: 'ArticleList',
              component: ArticleList,
              redirect: { name: 'ArticleListPublish' },
              meta: { title: '我的发布', icon: '' },
              children: [
                {
                  path: 'publish',
                  name: 'ArticleListPublish',
                  component: ArticleListPublish,
                  meta: { title: '已发布', icon: '', hidden: true }
                },
                {
                  path: 'pending-audit',
                  name: 'ArticleListPendingAudit',
                  component: ArticleListPendingAudit,
                  meta: { title: '待审核', icon: '', hidden: true }
                },
                {
                  path: 'audit-reject',
                  name: 'ArticleListAuditReject',
                  component: ArticleListAuditReject,
                  meta: { title: '未通过', icon: '', hidden: true }
                },
                {
                  path: 'draft',
                  name: 'ArticleListDraft',
                  component: ArticleListDraft,
                  meta: { title: '草稿箱', icon: '', hidden: true }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: '/your-site',
      name: 'Site',
      component: AppLayoutYourSite,
      redirect: { name: 'SitePages' },
      meta: { title: '云官网', icon: '' },
      children: [
        {
          path: 'pages',
          name: 'SitePages',
          component: SitePages,
          meta: { title: '页面配置', icon: 'page-config' }
        },
        {
          path: 'editor',
          name: 'SiteEditor',
          component: SiteEditor,
          meta: { title: '页面编辑', icon: '', hidden: true }
        },
        {
          path: 'product',
          name: 'Product',
          component: Product,
          redirect: { name: 'ProductList' },
          meta: { title: '产品服务', icon: 'product' },
          children: [
            {
              path: 'list',
              name: 'ProductList',
              component: ProductList,
              meta: { title: '全部产品服务', icon: '' }
            },
            {
              path: 'edit',
              name: 'ProductEdit',
              component: ProductEdit,
              meta: { title: '发布产品服务', icon: '' }
            }
          ]
        },
        {
          path: 'case',
          name: 'Case',
          component: Case,
          redirect: { name: 'CaseList' },
          meta: { title: '合作案例', icon: 'case' },
          children: [
            {
              path: 'list',
              name: 'CaseList',
              component: CaseList,
              meta: { title: '全部合作案例', icon: '' }
            },
            {
              path: 'edit',
              name: 'CaseEdit',
              component: CaseEdit,
              meta: { title: '添加合作案例', icon: '' }
            }
          ]
        }
      ]
    },
    {
      path: '/setting',
      name: 'Setting',
      component: AppLayoutSetting,
      redirect: { name: 'SettingPersonalInfo' },
      meta: { title: '账号设置', icon: '' },
      children: [
        {
          path: 'personal',
          name: 'SettingPersonal',
          component: SettingPersonal,
          redirect: { name: 'SettingPersonalInfo' },
          meta: { title: '个人设置', icon: 'personal' },
          children: [
            {
              path: 'info',
              name: 'SettingPersonalInfo',
              component: SettingPersonalInfo,
              meta: { title: '个人信息', icon: '' }
            },
            {
              path: 'password',
              name: 'SettingPersonalPassword',
              component: SettingPersonalPassword,
              meta: { title: '修改密码', icon: '' }
            },
            {
              path: 'bind',
              name: 'SettingPersonalBind',
              component: SettingPersonalBind,
              meta: { title: '账号绑定', icon: '' }
            }
          ]
        }
        // {
        //   path: 'company',
        //   name: 'SettingCompany',
        //   component: SettingCompany,
        //   redirect: { name: 'SettingCompanyInfo' },
        //   meta: { title: '企业设置', icon: 'company' },
        //   children: [
        //     {
        //       path: 'info',
        //       name: 'SettingCompanyInfo',
        //       component: SettingCompanyInfo,
        //       meta: { title: '企业信息', icon: '' }
        //     },
        //     {
        //       path: 'basic',
        //       name: 'SettingCompanyBasic',
        //       component: SettingCompanyInfo,
        //       meta: { title: '基础信息', icon: '' }
        //     },
        //     {
        //       path: 'credit',
        //       name: 'SettingCompanyCredit',
        //       component: SettingCompanyInfo,
        //       meta: { title: '诚信认证', icon: '' }
        //     }
        //   ]
        // }
      ]
    },
    {
      path: '*',
      name: '404',
      component: NotFound
    }
  ]
})
